export const SET_PAYROLL = 'COMISSIONED_PAYROLL/SET_PAYROLL';
export const SET_PARTIAL_PAYMENT_LIST = 'COMISSIONED_PAYROLL/SET_PARTIAL_PAYMENT_LIST';
export const SET_PAYROLL_LIST = 'COMISSIONED_PAYROLL/SET_PAYROLL_LIST';
export const SET_IS_LOADING = 'COMISSIONED_PAYROLL/SET_IS_LOADING';
export const SET_IS_LOADING_SINGLE_PAYROLL = 'COMISSIONED_PAYROLL/SET_IS_LOADING_SINGLE_PAYROLL';
export const SET_EMPLOYEE_UUID = 'COMISSIONED_PAYROLL/SET_EMPLOYEE_UUID';
export const CLEAR_PAYROLL = 'COMISSIONED_PAYROLL/CLEAR_PAYROLL';
export const CLEAR_PAYROLL_LIST = 'COMISSIONED_PAYROLL/CLEAR_PAYROLL_LIST';